import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface InputFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'email' | 'tel' | 'number' | 'password';
  error?: string;
  helperText?: string;
  disabled?: boolean;
  maxLength?: number;
  prefix?: string;
}

export const InputField = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  error,
  helperText,
  disabled = false,
  maxLength,
  prefix
}: InputFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = type === 'password' && showPassword ? 'text' : type;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-semibold text-[#111827]">
        {label}
      </label>
      
      <div className="relative">
        {prefix && (
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#6B7280] font-medium">
            {prefix}
          </span>
        )}
        
        <input
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          className={`w-full px-4 py-3 ${prefix ? 'pl-12' : ''} ${type === 'password' ? 'pr-12' : ''} rounded-[12px] border transition-all font-medium
            ${error 
              ? 'border-[#DC2626] bg-[#FEF2F2] text-[#DC2626] focus:border-[#DC2626] focus:ring-2 focus:ring-[#FEE2E2]' 
              : disabled
              ? 'border-[#E5E7EB] bg-[#F7F8FA] text-[#6B7280] cursor-not-allowed'
              : 'border-[#E5E7EB] bg-white text-[#111827] focus:border-[#FF6A2A] focus:ring-2 focus:ring-[#FFF5F0]'
            }
            placeholder:text-[#6B7280]
            outline-none
          `}
        />
        
        {type === 'password' && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-[#6B7280] hover:text-[#111827] transition-colors"
          >
            {showPassword ? (
              <EyeOff className="w-5 h-5" />
            ) : (
              <Eye className="w-5 h-5" />
            )}
          </button>
        )}
      </div>
      
      {(error || helperText) && (
        <p className={`text-xs ${error ? 'text-[#DC2626]' : 'text-[#6B7280]'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
};
